window.addEventListener('DOMContentLoaded', function () {
  const loginForm = document.querySelector('.login-form');
  const forgotForm = document.querySelector('.forgot-form');

  function handleHashChange() {
    if (window.location.hash === '#recover') {
      loginForm.style.display = 'none';
      forgotForm.style.display = 'flex';
    } else {
      loginForm.style.display = 'flex';
      forgotForm.style.display = 'none';
    }
  }

  // Check hash on page load
  handleHashChange();

  // Listen for hash changes
  window.addEventListener('hashchange', handleHashChange);
});
